import { mediaItems } from '@/mocks/baoliao';

const mediaImages: Record<string, string> = {
  'media-01': 'https://readdy.ai/api/search-image?query=Investigative%20journalism%20scene%20with%20recording%20device%20and%20dramatic%20lighting%2C%20warm%20crimson%20and%20dark%20tones%2C%20cinematic%20composition%20with%20shallow%20depth%20of%20field%2C%20abstract%20documentary%20style%2C%20moody%20atmosphere%2C%20editorial%20video%20thumbnail%20aesthetic&width=640&height=360&seq=media-01&orientation=landscape',
  'media-02': 'https://readdy.ai/api/search-image?query=Undercover%20investigation%20factory%20scene%20with%20dim%20lighting%20and%20industrial%20machinery%2C%20warm%20amber%20and%20dark%20charcoal%20tones%2C%20gritty%20cinematic%20style%2C%20secretive%20atmosphere%2C%20documentary%20expose%20aesthetic%2C%20dramatic%20shadows&width=640&height=360&seq=media-02&orientation=landscape',
  'media-03': 'https://readdy.ai/api/search-image?query=Corporate%20boardroom%20drama%20concept%20with%20empty%20chairs%20and%20scattered%20documents%2C%20warm%20gold%20and%20dark%20tones%2C%20cinematic%20lighting%20with%20spotlight%20effect%2C%20abstract%20business%20scandal%20style%2C%20editorial%20finance%20aesthetic&width=640&height=360&seq=media-03&orientation=landscape',
  'media-04': 'https://readdy.ai/api/search-image?query=Behind%20the%20scenes%20influencer%20lifestyle%20concept%20with%20camera%20equipment%20and%20warm%20lighting%2C%20soft%20amber%20and%20cream%20tones%2C%20intimate%20documentary%20style%2C%20candid%20atmosphere%2C%20editorial%20social%20media%20aesthetic&width=640&height=360&seq=media-04&orientation=landscape',
};

export default function MediaCards() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
            独家视频
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
            独家影像资料与暗访实录，视觉还原事件真相
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {mediaItems.map((item) => (
            <div
              key={item.id}
              className="group bg-background-50 rounded-lg border border-background-200/70 overflow-hidden cursor-pointer hover:border-primary-200 transition-all"
            >
              <div className="relative w-full aspect-video overflow-hidden">
                <img
                  src={mediaImages[item.imageSeq]}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-black/20 group-hover:bg-black/30 transition-colors"></div>
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-primary-500/90 group-hover:bg-primary-500 transition-colors">
                    <i className="ri-play-fill text-background-50 text-xl md:text-2xl ml-0.5"></i>
                  </div>
                </div>
                <div className="absolute bottom-2 right-2 px-2 py-0.5 rounded bg-black/70 text-background-50 text-xs">
                  {item.duration}
                </div>
              </div>
              <div className="p-3 md:p-4">
                <h3 className="font-medium text-foreground-900 text-sm group-hover:text-primary-600 transition-colors line-clamp-2 mb-1">
                  {item.title}
                </h3>
                <span className="text-xs text-foreground-500">{item.views} 次播放</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}